/** Encodes values deterministically, supports arrays & Date */
const encodeValue = (value) => {
	if (value instanceof Date) return value.toISOString();
	return String(value);
};

/**
 * Builder to create a query with querystring values.
 *
 * // Example usage:
 * const url = QueryBuilder.Create('https://example.com/api')
 *    .withParam('foo', 'bar')
 *    .withParam('ids', [1, 2, 3])
 *    .withParam('date', new Date())
 *    .toString();
 */
export default class QueryBuilder {
	constructor(baseUrl) {
		this.base = '';
		this.params = {};

		// If baseUrl includes a query, merge it into internal params
		const [path, query] = baseUrl.split('?', 2);
		this.base = path;

		if (query) {
			const existing = new URLSearchParams(query);
			existing.forEach((v, k) => this.push(k, v));
		}
	}

	static Create(baseUrl) {
		return new QueryBuilder(baseUrl);
	}

	/** Add a single param; ignores null/undefined by default */
	withParam(name, value, options) {
		const includeNull = options?.includeNull ?? false;

		if (value === undefined || value === null) {
			if (includeNull) {
				this.push(name, ''); // yields ?key=
			}
			return this;
		}

		if (Array.isArray(value)) {
			value
				.filter((v) => v !== undefined && (includeNull || v !== null))
				.forEach((v) => this.push(name, encodeValue(v)));
		} else {
			this.push(name, encodeValue(value));
		}
		return this;
	}

	/** Build final URL */
	toString() {
		const usp = new URLSearchParams();
		Object.entries(this.params).forEach(([key, values]) => {
			values.forEach((v) => usp.append(key, v));
		});
		const qs = usp.toString();
		return qs ? `${this.base}?${qs}` : this.base;
	}

	push(name, value) {
		if (!this.params[name]) {
			this.params[name] = [];
		}
		this.params[name].push(value);
	}
}
